import { Autocomplete } from '@mui/material'
import MuiTextField from '@mui/material/TextField'

type Props = {
  value?: string
  options: string[]
  freeSolo?: boolean
  onChange: (value: string | null) => void
}

export default function ComboboxString({ value, options, freeSolo, onChange }: Props) {
  return (
    <Autocomplete
      freeSolo={freeSolo}
      options={options}
      renderInput={(params) => (
        <MuiTextField value={value} onChange={(e) => onChange(e.target.value)} {...params} size="small" />
      )}
      onChange={(_, val) => onChange(val)}
    />
  )
}
